"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

require("./bouncer.css");

var Bouncer = function Bouncer(props) {
  var dataTestId = props.dataTestId,
      size = props.size,
      gray = props.gray;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, "oui-bouncers", "oui-bouncer-".concat(size), gray ? "oui-gray" : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-bouncer-1"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-bouncer-2"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-bouncer-3"
  }));
};

Bouncer.propTypes = {
  size: _propTypes["default"].oneOf(["sm", "md", "lg"]),
  dataTestId: _propTypes["default"].string,
  gray: _propTypes["default"].bool
};
Bouncer.defaultProps = {
  size: "md",
  dataTestId: "orion-bouncer",
  gray: false
};
Bouncer.displayName = "OrionBouncer";
var _default = Bouncer;
exports["default"] = _default;